// react
import { useSelector } from 'react-redux';

// relative
import ReleaseNotesButton from './ReleaseNotesButton';

/**
 * ReleaseNotesIndicator - Shows the release notes button in AppBar when there's news
 * Reads from Redux state to determine if there are release notes to show
 */
const ReleaseNotesIndicator = () => {
  const { status, releaseNotes, version } = useSelector(
    (state) => state.systemBanner,
  );

  // Only show button if status is 'news' and there are release notes
  if (status !== 'news' || !releaseNotes) {
    return null;
  }

  return <ReleaseNotesButton releaseNotes={releaseNotes} version={version} />;
};

export default ReleaseNotesIndicator;
